import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2, ShieldCheck } from "lucide-react";
import { ImpicPeriodo, StatusPill, deadlineText, card } from "@/components/ImpicPeriodo";
import { ImpicResponsaveis } from "@/components/ImpicResponsaveis";

function PeriodList({ periods, sel, onSel }) {
  return (
    <ul className="space-y-2" data-testid="impic-periods">
      {periods.map((p) => (
        <li key={p.key}>
          <button onClick={() => onSel(p.key)} data-testid={`impic-period-${p.key}`}
            className={`w-full text-left rounded-xl border px-4 py-3 transition-[border-color,background-color] ${sel === p.key ? "border-[color:var(--hc,#2B3A4A)] bg-white shadow-sm" : "border-slate-200 bg-white/60 hover:bg-white"}`}>
            <div className="flex items-center justify-between gap-2">
              <span className="font-semibold navy-text">{p.label}</span>
              <StatusPill p={p} short />
            </div>
            <div className="text-[13px] text-slate-500 mt-1">
              {p.count} {p.count === 1 ? "transação" : "transações"}
              {p.count > 0 && (p.missing_count ? <span className="text-amber-700"> · {p.missing_count} campos em falta</span> : <span className="text-green-700"> · completo</span>)}
            </div>
            <div className="text-[12px] text-slate-400 mt-0.5">{deadlineText(p)}</div>
          </button>
        </li>
      ))}
    </ul>
  );
}

export default function Obrigacoes() {
  const { user } = useAuth();
  const [periods, setPeriods] = useState(null);
  const [sel, setSel] = useState(null);
  const load = useCallback(() => api.get("/impic/periods").then(({ data }) => {
    setPeriods(data);
    setSel((s) => s || (data.find((p) => p.ended && p.status !== "submetido" && p.count) || data.find((p) => p.ended) || data[0]).key);
  }), []);
  useEffect(() => { load(); }, [load]);
  const isDir = user.role === "direccao";
  const pick = (k) => {
    setSel(k);
    if (window.innerWidth < 1024) setTimeout(() => document.querySelector("[data-testid=impic-period-detail]")?.scrollIntoView({ behavior: "smooth", block: "start" }), 300);
  };

  return (
    <div className="space-y-6" data-testid="obrigacoes-page">
      <div>
        <h1 className="font-heading text-3xl sm:text-4xl navy-text">Obrigações legais</h1>
        <div className="mt-4 flex gap-2 border-b border-slate-200">
          <span className="inline-flex items-center gap-1.5 px-1 pb-2.5 -mb-px border-b-2 border-[color:var(--hc,#2B3A4A)] font-semibold navy-text text-sm" data-testid="tab-impic">
            <ShieldCheck size={16} /> Comunicação IMPIC
          </span>
        </div>
        <p className="text-sm text-slate-500 mt-3 max-w-3xl">
          Vendas e arrendamentos concluídos em cada trimestre, preenchidos a partir dos processos. Depois de validar, exporte o ficheiro e submeta-o no portal do IMPIC. A aplicação não submete nem guarda as credenciais do portal.
        </p>
      </div>
      {!periods ? <div className="py-16 grid place-items-center text-slate-400"><Loader2 className="animate-spin" /></div> : (
        <div className="grid grid-cols-1 lg:grid-cols-[320px_1fr] gap-6 items-start">
          <div className="space-y-6">
            <PeriodList periods={periods} sel={sel} onSel={pick} />
            <div className={card}><ImpicResponsaveis canEdit={isDir} /></div>
          </div>
          {sel && <ImpicPeriodo key={sel} pkey={sel} isDir={isDir} onChange={load} />}
        </div>
      )}
    </div>
  );
}
